import { http } from '@/core/api/';
const apiUrl = 'api/inventoryTransferMaterialsAndEquipments';

export default {
  getStatuses() {
    return http.get(`${apiUrl}/statuses`);
  },
  search(params) {
    return http.get(`${apiUrl}/search`, { params });
  },
  get(id) {
    return http.get(`${apiUrl}/${id}`);
  },
  approve(id, data) {
    return http.patch(`${apiUrl}/${id}/approve`, data);
  },
  reject(id, data) {
    return http.patch(`${apiUrl}/${id}/reject`, data);
  },
  sendToRoute(id, data) {
    return http.patch(`${apiUrl}/${id}/sendtoroute`, data);
  },
  getHistory(id, params) {
    return http.get(`${apiUrl}/${id}/history`, { params });
  },
};
